import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { apiCallInitialState } from 'types/ApiCall';
import { ResponseErrorPayload } from 'utils/request';
import { checkInsSliceSaga } from './saga';
import { CheckInsSliceState, ICheckInBatch } from './types';

export const initialState: CheckInsSliceState = {
  batches: {
    ...apiCallInitialState,
    data: [],
  },
  eligibleCount: {
    ...apiCallInitialState,
    data: null,
  },
  sendBatch: apiCallInitialState,
};

const slice = createSlice({
  name: 'checkInsSlice',
  initialState,
  reducers: {
    loadBatchesRequest(state, action: PayloadAction<void>) {
      state.batches.loading = true;
      state.batches.error = undefined;
    },
    loadBatchesSuccess(
      state,
      action: PayloadAction<{ data: Array<ICheckInBatch> }>,
    ) {
      state.batches.loading = false;
      state.batches.data = action.payload.data;
    },
    loadBatchesFailed(state, action: PayloadAction<ResponseErrorPayload>) {
      state.batches.loading = false;
      state.batches.error = action.payload;
    },
    loadEligibleCountRequest(state, action: PayloadAction<void>) {
      state.eligibleCount.loading = true;
      state.eligibleCount.error = undefined;
    },
    loadEligibleCountSuccess(state, action: PayloadAction<{ count: number }>) {
      state.eligibleCount.loading = false;
      state.eligibleCount.data = action.payload.count;
    },
    loadEligibleCountFailed(
      state,
      action: PayloadAction<ResponseErrorPayload>,
    ) {
      state.eligibleCount.loading = false;
      state.eligibleCount.error = action.payload;
    },
    sendBatchRequest(state, action: PayloadAction<void>) {
      state.sendBatch.loading = true;
      state.sendBatch.error = undefined;
    },
    sendBatchSuccess(state, action: PayloadAction<{ data: ICheckInBatch }>) {
      state.sendBatch.loading = false;
      state.sendBatch.data = action.payload.data;
    },
    sendBatchFailed(state, action: PayloadAction<ResponseErrorPayload>) {
      state.sendBatch.loading = false;
      state.sendBatch.error = action.payload;
    },
  },
});

export const { actions: checkInsSliceActions } = slice;

export const useCheckInsSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: checkInsSliceSaga });
  return { actions: slice.actions };
};
